import { defineStore, acceptHMRUpdate } from 'pinia';

interface State {
  isVisible: boolean;
}

export const useNeoDotStore = defineStore('neo-dot', {
  state: (): State => {
    return {
      isVisible: false,
    };
  },
  // getters: {},
  actions: {
    togglePopup() {
      this.isVisible = !this.isVisible;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNeoDotStore, import.meta.hot));
}
